import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import FeatureList, { Feature } from '../../FeatureList';
import type { SectionProps } from './section';
import ownClasses from './style/feature-list-section.module.scss';
interface OwnProps {
  sectionTitle?: string;
  features: Feature[];
}
type Props = SectionProps & OwnProps;
export function FeatureListSection(t0) {
  const $ = _c(13);
  const {
    sectionTitle: t1,
    features,
    classes: t2
  } = t0;
  const sectionTitle = t1 === undefined ? "Dati Principali" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const classes = t3;
  let t4;
  if ($[2] !== classes) {
    t4 = classnames(...classes, "main-data");
    $[2] = classes;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classnames("headline-6", ownClasses["section-title"]);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== sectionTitle) {
    t6 = <h2 className={t5}>{sectionTitle}</h2>;
    $[5] = sectionTitle;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== features) {
    t7 = <FeatureList features={features} />;
    $[7] = features;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t7) {
    t8 = <section className={t4}>{t6}{t7}</section>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}
export default FeatureListSection;